import { createSelector } from 'reselect'

const customerContextIsComplete = createSelector([data => data], state => {
  if (!state.customerContext.data) return false
  let { party_link, organisation_party_link } = state.customerContext.data
  return party_link && organisation_party_link
})

export { customerContextIsComplete }
